import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "colorPicker",
    "colorInput",
    "header",
    "button",
    "link",
    "radioOuter",
    "radioInner"
  ]

  static values = {
    color: String
  }

  connect() {
    this.updatePreview(this.colorValue)
  }

  updateColor(event) {
    const color = event.target.value
    this.colorInputTarget.value = color
    this.updatePreview(color)
  }

  updateColorFromInput(event) {
    const color = event.target.value
    if (this.isValidHex(color)) {
      this.colorPickerTarget.value = color
      this.updatePreview(color)
    }
  }

  updatePreview(color) {
    // Update header background with light tint
    if (this.hasHeaderTarget) {
      this.headerTarget.style.backgroundColor = `${color}10`
    }

    // Update button
    if (this.hasButtonTarget) {
      this.buttonTarget.style.backgroundColor = color
    }

    // Update link
    if (this.hasLinkTarget) {
      this.linkTarget.style.color = color
    }

    // Update radio button
    if (this.hasRadioOuterTarget) {
      this.radioOuterTarget.style.borderColor = color
    }
    if (this.hasRadioInnerTarget) {
      this.radioInnerTarget.style.backgroundColor = color
    }
  }

  isValidHex(color) {
    return /^#[0-9A-Fa-f]{6}$/.test(color)
  }
}
